import React, { FC } from 'react';
import styles from './index.module.scss';
import ReactMarkdown from 'src/common/Markdown';
import { useTranslation } from 'react-i18next';
import { ITenderKeywordHighlight } from 'src/models/procurements/Preview/types';
import classNames from 'classnames';
import { useTenderPreview } from 'src/models/procurements/Preview/hooks';
import { TenderFile } from 'src/shared';
interface IProps {
  highlight: ITenderKeywordHighlight;
}
export const TenderPreviewMatchesItem: FC<IProps> = ({ highlight }) => {
  const { data } = useTenderPreview();
  const id = data?.id;
  const { context, value, color, targetPath } = highlight;
  const { t } = useTranslation();
  const source = !targetPath ? t(`Tenders.NoticeSource.${context}`) : context;

  return (
    <div className={styles.match}>
      <ReactMarkdown className={classNames(styles.content, color && styles[color])}>{value}</ReactMarkdown>
      {source && (
        <div className={styles.source}>
          <span className={styles.sourceLabel}>{t('Tenders.source')}</span>
          {!!targetPath && !!id ? (
            <TenderFile
              procurementId={id}
              targetPath={targetPath}
              displayName={source}
              eventSource="Matches - Tender Preview"
              keywordHighlight={highlight}
            />
          ) : (
            <span className={styles.sourceName}>{source}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default TenderPreviewMatchesItem;
